
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/timeline",
      function () {
        return require("private-next-pages/material-ui/api/timeline.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/timeline"])
      });
    }
  